export const Site = Object.freeze({
    ADVANTAGE: 'advantage',
    VENDOR_CENTRAL: 'vendorCentral',

    validator(value) {
        return ['advantage', 'vendorCentral'].includes(value);
    },
});
